import React, { Component } from 'react';
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class textileHorizon extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div style={{ width: '100%', minHeight: '100vh', height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
                <iframe
                    src="textile_horizon.html"
                    title="Textile Horizon 2026"
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        display: 'block'
                    }}
                />
            </div>
        );
    }
}

export default withRouter(connect(null, {})(textileHorizon));
